import styled from 'styled-components';

export const Tr = styled.tr.withConfig({ displayName: '-Tr' })`

	& > td{
		background: ${props => props.isHover ? "#0d609d" : props.color === "red" ? "#fff8f8" : "transparent"};
		color: ${props => props.isHover ? "#ffffff" : "#212529"};
	}


	${props => props.color ? `
		& > td:first-child{
			padding-left: 32px;
		}

		& > td:first-child::before{

			content: "";
			display: inline-block;
			margin-right: 4px;
			width: 11px;
			height: 11px;
			transform: translateY(.5px);
			border-radius: ${props.color === 'darkgreen' ? 0 : 11}px;

			background-color: ` + (
			props.color === "red" ? "#ff0000" :
				props.color === "yellow" ? "#ffbb39" :
					props.color === "green" ? "#33be00" :
						props.color === "gray" ? "#828282" :
							props.color === "white" ? "#ffffff" :
								props.color === "darkgreen" ? "#006400" :
									""
		) + `;

			border: ` + (
			props.color === "red" ? "0px" :
				props.color === "yellow" ? "0px" :
					props.color === "green" ? "0px" :
						props.color === "gray" ? "0px" :
							props.color === "white" ? "1px solid #dedede" :
								"0px"
		) + `;
		}
	` : null}
`;
